import { Component, OnInit, Injectable, Input, NgZone, HostBinding, HostListener } from '@angular/core';
import { NbDialogRef, NbIconLibraries } from '@nebular/theme';

@Component({
  selector: 'ngx-modal-generic',
  templateUrl: './modal-generic.component.html',
  styleUrls: ['./modal-generic.component.scss'],
})

export class ModalGenericComponent implements OnInit {

  @Input('context.id') id: number;
  @Input('context.title') titleModal: string;
  loading: boolean;
  innerWidth: number;
  maximize: boolean = false;
  width: any;
  height: any;
  style: Object;


  constructor(
     public ref: NbDialogRef<ModalGenericComponent>,
     public iconsLibrary: NbIconLibraries,
     public ngZone: NgZone
  ) {
    this.loading = false;
    iconsLibrary.registerFontPack('font-awesome', { packClass: 'far', iconClassPrefix: 'fa' });
    iconsLibrary.registerFontPack('font-awesome', { packClass: 'fas', iconClassPrefix: 'fa' });
  }

  ngOnInit() {

    this.width = window.innerWidth;
    this.height = window.innerHeight;

    this.loadData();
  }

  @HostListener('window:resize', ['$event'])
  resizeWidthHeight() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;

  }

  cancel() {
    this.ref.close();
  }

  submit() {

  }

  resize() {
    if (this.maximize) {
      this.maximize = false;
    } else {
      this.maximize = true;
    }
  }

  styleMax(): object {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    return this.style = { 'width': this.width + "px", 'height': this.height + "px" };
  }
  styleNormal(): object {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    return this.style = { 'width': (this.width*0.8) + "px", 'height': (this.height*0.8) + "px" };
  }

  loadData(): void {
  }


  refresh() {

  }

}
